// IMP-384: i18n 문자열 {{key}} 치환 공용 헬퍼.
// Translate 는 interpolation 미지원이므로 interpolate(t('key'), { name, count }) 형태로 조합해 사용한다.
// (Translate 와 별도 모듈로 분리 — config/Translate 를 mock 하는 기존 테스트에 영향을 주지 않기 위함)
export const interpolate = (template, vars) => {
    if (typeof template !== 'string') return template;
    return Object.keys(vars || {}).reduce(
        (acc, key) => acc.split(`{{${key}}}`).join(String(vars[key])),
        template,
    );
};
